import React, { Component } from 'react';
import NavBar from './components/NavBar';
// import { msalConfig, tokenRequest, loginRequest, graphConfig } from './config';
// import moment from 'moment';
// import qs from 'qs';
// import { UserAgentApplication } from 'msal';
import {myMSALObj,entityList,functionList,entityMap,functionMap, frequencyList, languageList,organizationMap,environmentSetUp,environmentSelection} from './components/Configurations'
// import {OAuth2} from 'fetch-mw-oauth2';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';


class Create extends Component{

    constructor(props){
        super(props)
        this.state = {
            accessToken:sessionStorage.getItem("accessToken"),
            expiresOn:sessionStorage.getItem("expiresOn"),
            name:"",
            technicalName:"",
            description:"",
            entityID:"",
            entityName:"",
            organizationID:"UNS",
            organizationName:"United Nations",
            sensitivityLevel:"",
            linkToData:"",
            startDate:"",
            showStartDateCalendar:false,
            closeDate:"",
            showCloseDateCalendar:false,
            updatedOn:"",
            showUpdatedOnCalendar:false,
            pii:"",
            status:"",
            updatedBy:"",
            isPublic:false,
            isUnclassified:false,
            isConfidential:false,
            isStrictlyConfidential:false,
            expert:"",
            expertEmail:"",
            owner:"",
            function:"",
            frequency:"",
            language:"",
            databaseManagementSystem:"",
            qualifiedName:"",
            glossaryTerms:[],
            
        }
        this.handleLogOut = this.handleLogOut.bind(this); 
        this.handleChangeStartDate = this.handleChangeStartDate.bind(this);
        this.handleChangeCloseDate = this.handleChangeCloseDate.bind(this);
        this.handleChangeUpdatedOnDate = this.handleChangeUpdatedOnDate.bind(this);
        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleChangeTechnicalName = this.handleChangeTechnicalName.bind(this);
        this.handleChangeEntityID = this.handleChangeEntityID.bind(this);
        this.handleChangePII = this.handleChangePII.bind(this);
        this.handleChangeSensitivityLevel = this.handleChangeSensitivityLevel.bind(this);
        this.handleChangePointOfContact = this.handleChangePointOfContact.bind(this);
        this.handleChangeDatasetOwner = this.handleChangeDatasetOwner.bind(this);
        this.handleChangePointOfContactEmail = this.handleChangePointOfContactEmail.bind(this);
        this.handleChangeOrganization = this.handleChangeOrganization.bind(this);
        this.handleChangeFunction = this.handleChangeFunction.bind(this);
        this.handleChangeLinkToData = this.handleChangeLinkToData.bind(this);
        this.handleChangeUpdatedBy = this.handleChangeUpdatedBy.bind(this);
        this.handleChangeFrequency = this.handleChangeFrequency.bind(this);
        this.handleChangeDescription = this.handleChangeDescription.bind(this);
        this.handleChangeStatus = this.handleChangeStatus.bind(this);
        this.handleChangeLanguage = this.handleChangeLanguage.bind(this);
        this.handleChangeDatabaseManagementSystem = this.handleChangeDatabaseManagementSystem.bind(this);
        this.handleSubmitRecord = this.handleSubmitRecord.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this)
    }

    handleCreate(){
        this.props.history.push({
            pathname:'/create'
        })
    }

    handleCancel(){
        this.props.history.push({
            pathname:'/'
        })
    }

    handleLogOut(){
        sessionStorage.setItem('user','');
        sessionStorage.setItem('email','');
        sessionStorage.setItem('keyword','');
        sessionStorage.setItem('accessToken','');
        sessionStorage.setItem('expiresOn','');
        sessionStorage.setItem('role','');
        this.props.history.push('/logout');
        myMSALObj.logout();
        
      }

    handleChangeStartDate(date){
        this.setState({
            startDate:date,
            showStartDateCalendar:false
            })
    }

    handleChangeCloseDate(date){
        this.setState({
            closeDate:date,
            showCloseDateCalendar:false
            })
    }

    handleChangeUpdatedOnDate(date){
        this.setState({
            updatedOn:date,
            showUpdatedOnCalendar:false
            })
    }

    handleChangeName(event){
        this.setState({name:event.target.value})
    }

    handleChangeTechnicalName(event){
        this.setState({technicalName:event.target.value})
    }

    handleChangeEntityID(event){
        this.setState({
            entityID:event.target.value,
            entityName:entityMap[event.target.value]
        })
    }

    handleChangePII(event){
        this.setState({pii:event.target.value})
    }

    handleChangeSensitivityLevel(event){
        this.setState({sensitivityLevel:event.target.value})
    }

    handleChangePointOfContact(event){
        this.setState({expert:event.target.value})
    }

    handleChangePointOfContactEmail(event){
        this.setState({expertEmail:event.target.value})
    }

    handleChangeDatasetOwner(event){
        this.setState({owner:event.target.value})
    }

    handleChangeOrganization(event){
        this.setState({
            organizationName:event.target.value,
            organizationID:organizationMap[event.target.value]
            })
    }

    handleChangeFunction(event){
        this.setState({
            function:event.target.value
        })
    }

    handleChangeLinkToData(event){
        this.setState({
            linkToData:event.target.value
        })
    }

    handleChangeUpdatedBy(event){
        this.setState({
            updatedBy:event.target.value
        })
    }

    handleChangeFrequency(event){
        this.setState({
            frequency:event.target.value
        })
    }

    handleChangeDescription(event){
        this.setState({
            description:event.target.value
        })
    }

    handleChangeStatus(event){
        this.setState({
            status:event.target.value
        })
    }

    handleChangeLanguage(event){
        this.setState({
            language:event.target.value
        })
    }

    handleChangeDatabaseManagementSystem(event){
        this.setState({
            databaseManagementSystem:event.target.value
        })
    }

    async handleSubmitRecord(){
        // console.log("clicked submit!")
        const payload = {
            "referredEntities": {},
            "entity": {
                "typeName": "UN_Manual_Input",
                "attributes": {

                    "name":this.state.name,
                    "Technical_Name":this.state.technicalName,
                    "Entity_ID":this.state.entityID,
                    "Start_Date":this.state.startDate.getTime(),
                    "Close_Date":this.state.closeDate===""?this.state.closeDate:this.state.closeDate.getTime() ,
                    "Sensitivity_Level":this.state.sensitivityLevel,
                    "PII":this.state.pii,
                    "Dataset_Owner":this.state.owner,
                    "Point_Of_Contact":this.state.expert,
                    "Point_Of_Contact_Email":this.state.expertEmail,
                    "Organization":this.state.organizationName,
                    "Organization_ID":this.state.organizationID,
                    "Entity":this.state.entityName,
                    "Function":this.state.function,
                    "Description":this.state.description,
                    "Link_To_Data":this.state.linkToData,
                    "Updated_On":"",
                    "Updated_By":this.state.updatedBy,
                    "Status":this.state.status,
                    "Frequency":this.state.frequency,
                    "Language":this.state.language,
                    "Database_Management_System":this.state.databaseManagementSystem,
                    "UniteApps_ID":"",
                    "qualifiedName":this.state.name
                },
                "status": "ACTIVE",
                "createdBy": "Eric Cai",
                "updatedBy": "Eric Cai",
                "version": 1.0
            }
        }

        let currentTime = new Date().getTime()/1000;
        if (sessionStorage.getItem('accessToken') === null || sessionStorage.getItem('expiresOn')-18000<=currentTime+60 || sessionStorage.getItem('accessToken') === "undefined"){
            // console.log('token is bad.')
            // const res = await fetch(proxyUrl+tokenUrl,requestOptions);
            // const res = await fetch("https://data-catalog-token-server.azurewebsites.net/api/getToken")
            const res = await fetch(environmentSetUp["purviewAccessToken"][environmentSelection])
            const data = await res.json()
            var currentDateTime = new Date();
            console.log('the new code');
            currentDateTime.setSeconds(currentDateTime.getSeconds() + data.expires_in);
            this.setState({
            accessToken:data.access_token,
            expiresOn:new Date(currentDateTime).getTime()/1000
                //accessToken:data.accessToken,
                //expiresOn:new Date(data["expiresOn"]).getTime()/1000
            },()=>{
                    sessionStorage.setItem('accessToken',this.state.accessToken);
                    sessionStorage.setItem('expiresOn',this.state.expiresOn);
                    // fetch("https://sys-purview.catalog.purview.azure.com/api/atlas/v2/entity",{
                    fetch(environmentSetUp["saveChangesBaseUrl"][environmentSelection],{
                        method:"POST",
                        headers:{
                            'Authorization':'Bearer ' + this.state.accessToken,
                            'Content-Type': 'application/json'
                        },
                        body:JSON.stringify(payload)
                    }).then(
                        this.props.history.push({
                            pathname:'/'
                        })
                    )
                })
        }else{
            // console.log('token is good.')
            // fetch("https://sys-purview.catalog.purview.azure.com/api/atlas/v2/entity",{
            fetch(environmentSetUp["saveChangesBaseUrl"][environmentSelection],{
                    method:"POST",
                    headers:{
                        'Authorization':'Bearer ' + this.state.accessToken,
                        'Content-Type': 'application/json'
                    },
                    body:JSON.stringify(payload)
                }).then(
                    this.props.history.push({
                        pathname:'/'
                    })
                )
        }

    }

    render(){
        if(sessionStorage.getItem("role")!=="curator"){
            return(
                <h2>Not authorized</h2>
            )
        }else{
            // console.log(this.state)
            return(
                <React.Fragment>
                    <NavBar handleLogOut={this.handleLogOut}  handleCreate={this.handleCreate}/>
                    <div className="create-main">
                        <nav aria-label="breadcrumb w-100" className="mb-4">
                            <ol className="breadcrumb-content breadcrumb bg-light w-100 mr-0 float-left">
                                <li className="breadcrumb-item small"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active small">Create</li>
                            </ol>
                        </nav>

                        <div className="w-100 px-3 mx-0">
                            <h1 className="w-100 px-5 mx-2 pb-1 details-title font-weight-bold float-left">
                                Create a new data entry   
                            </h1>
                        </div>
                        <div className="w-100 px-5">
                            <button title="Please make sure all the fields with * are filled" type="button"
                                    className="submit-new-entry btn btn-outline-success btn-sm float-right details-button shadow font-weight-bold m-1" disabled={this.state.name!==""&&this.state.technicalName!==""&&this.state.entityID!==""&&this.state.startDate!==""&&this.state.sensitivityLevel!==""&&this.state.pii!==""&&this.state.owner!==""&&this.state.expert!==""&&this.state.expertEmail!==""&&this.state.organizationName!==""?false:true}
                                    onClick={this.handleSubmitRecord}><i className="far fa-check-circle"></i>   Submit</button>
                            <button type="button"  title="Cancel the action"
                                    className="btn btn-outline-success btn-sm float-right details-button shadow font-weight-bold m-1" 
                                    onClick={this.handleCancel}
                                        ><i className="fas fa-ban"></i>   Cancel</button>
                        </div>
                        <ul className="nav nav-tabs my-1 mx-5 px-3 pt-2 float-left w-75 ">
                            <li className="nav-item">
                                <a className="nav-link active content-tab" data-toggle="tab" id="primary-tab" href="#details-content">Details</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link content-tab"  data-toggle="tab" id="secondary-tab" href="#data-content" >Data</a>
                            </li>
                        </ul>
                        
                        <div className="tab-content">
                            <div id="details-content" className="tab-pane fade show active">
                                <div className="w-50 float-left px-5 my-2">
                                    
                                    <div>
                                        <p className="px-4 pt-2 mb-1 text-uppercase text-secondary font-weight-bold" title="DATASET TITLE/DATASET NAME" >
                                        name<span className="asterisk">*</span>
                                        </p>
                                        <input type="text" class="mx-4 w-75 form-control form-control-sm" onChange={this.handleChangeName} ></input>
                                    </div>
                                    
                                    <div>
                                        <p className="px-4 pt-2 mb-1 text-uppercase text-secondary font-weight-bold" title="Abbreviation of the Entitiy/Department Name">
                                        entity<span className="asterisk">*</span>
                                        </p>
                                        <select  className="form-control form-control-sm w-75 mx-4" onChange={this.handleChangeEntityID} >
                                            <option disabled selected >--please pick an entity--</option>
                                            {
                                                entityList.map(item=>{
                                                    return( <option title={entityMap[item]} >{item}</option> )
                                                })
                                            }   
                                        </select>
                                    </div>
                                    
                                    <div>
                                        <p className="px-4 pt-2 mb-1 text-uppercase text-secondary font-weight-bold" title="Earliest content date inside the dataset" >
                                        start date<span className="asterisk">*</span>
                                        </p>
                                        <input type="text" class="mx-4 w-75 form-control form-control-sm"  value={this.state.startDate.toLocaleString()} onFocus={()=>this.setState({showStartDateCalendar:true})} />
                                        <Calendar className={this.state.showStartDateCalendar === true? "":"hide"}
                                                    value={this.state.startDate}
                                                    onChange={this.handleChangeStartDate} />
                                    </div>
                                    
                                    <div>
                                        <p className="px-4 pt-2 mb-1 text-uppercase text-secondary font-weight-bold" title="Latest content date inside the dataset">
                                        close date
                                        </p>
                                        <input type="text" class="mx-4 w-75 form-control form-control-sm" value={this.state.closeDate.toLocaleString()} onFocus={()=>this.setState({showCloseDateCalendar:true})} />
                                        <Calendar className={this.state.showCloseDateCalendar === true? "":"hide"}
                                                    value={this.state.closeDate}
                                                    onChange={this.handleChangeCloseDate} />
                                    </div>
                                    
                                    <div>
                                        <p className="px-4 pt-2 mb-1 text-uppercase text-secondary font-weight-bold" title="NAME">
                                        point of contact<span className="asterisk">*</span>
                                        </p>
                                        <input type="text" class="mx-4 w-75 form-control form-control-sm" onChange={this.handleChangePointOfContact} ></input>
                                    </div>
                                    
                                    <div>
                                        <p className="px-4 pt-2 mb-1 text-uppercase text-secondary font-weight-bold" title="EMAIL">
                                        point of contact email<span className="asterisk">*</span>
                                        </p>
                                        <input type="text" class="mx-4 w-75 form-control form-control-sm" onChange={this.handleChangePointOfContactEmail} ></input>
                                    </div>

                                    <div> 
                                        <p className="px-4 pt-2 mb-1 text-uppercase text-secondary font-weight-bold">
                                        function (Hover to see description)
                                        </p>
                                        <select  className="form-control form-control-sm w-75 mx-4" onChange={this.handleChangeFunction} >
                                            <option disabled selected >--please pick a function--</option>
                                            {   
                                                functionList.map(item=>{
                                                    return( <option title={functionMap[item]} >{item}</option> )
                                                })
                                            }   
                                        </select>
                                    </div>

                                    <div>
                                        <p className="px-4 pt-2 mb-1 text-uppercase text-secondary font-weight-bold" title="Description of the dataset">
                                        description
                                        </p>
                                        <textarea class="mx-4 w-75 form-control form-control-sm" rows="4" onChange={this.handleChangeDescription} ></textarea>
                                    </div>

                                    <div>
                                        <p className="px-4 pt-2 mb-1 text-uppercase text-secondary font-weight-bold" title="Language data set is available in">
                                        language
                                        </p>
                                        <select  className="form-control form-control-sm w-75 mx-4" onChange={this.handleChangeLanguage} >
                                            <option disabled selected >--please pick a language--</option>
                                            {
                                                languageList.map(item=>{
                                                    return( <option>{item}</option> )
                                                })
                                            }   
                                        </select>
                                    </div>
                                
                                
                                </div>
                                <div className="w-50 float-right px-5 my-2">
                                    
                                    <div>
                                        <p className="px-4 pt-2 mb-1 text-uppercase text-secondary font-weight-bold" title="ORIGINAL DATA SET TITLE/NAME">
                                        technical name<span className="asterisk">*</span>
                                        </p>
                                        <input type="text" class="mx-4 w-75 form-control form-control-sm" onChange={this.handleChangeTechnicalName}></input>
                                    </div>
                                    
                                    <div>
                                        <p className="px-4 pt-2 mb-0 text-uppercase text-secondary font-weight-bold" title="Personal Identifiable Information">
                                        PII<span className="asterisk">*</span>
                                        </p>
                                        <form className="px-4 mb-2" onChange={this.handleChangePII} >
                                            <div class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" id="customRadioInline1" name="customRadioInline1" className="custom-control-input" value="YES" />
                                            <label class="custom-control-label small" for="customRadioInline1">Yes</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" id="customRadioInline2" name="customRadioInline1" className="custom-control-input" value="NO" />
                                            <label class="custom-control-label small" for="customRadioInline2">No</label>
                                            </div>
                                        </form>
                                    </div>
                                    
                                    <div>
                                        <p className="px-4 pt-2 mb-2 text-uppercase text-secondary font-weight-bold" title="Security Classification Level">
                                            sensitivity level<span className="asterisk">*</span>
                                        </p>
                                        <form className="px-4" onChange={this.handleChangeSensitivityLevel} >
                                            <div class="custom-control custom-radio">
                                                <input type="radio" id="customRadio1" name="customRadio" class="custom-control-input" value="PUBLIC" />
                                                <label class="custom-control-label small" for="customRadio1">PUBLIC</label>
                                            </div>
                                            <div class="custom-control custom-radio">
                                                <input type="radio" id="customRadio2" name="customRadio" class="custom-control-input" value="NOT CLASSIFIED" />
                                                <label class="custom-control-label small" for="customRadio2">NOT CLASSIFIED</label>
                                            </div>
                                            <div class="custom-control custom-radio">
                                                <input type="radio" id="customRadio3" name="customRadio" class="custom-control-input" value="CONFIDENTIAL" />
                                                <label class="custom-control-label small" for="customRadio3">CONFIDENTIAL</label>
                                            </div>
                                            <div class="custom-control custom-radio">
                                                <input type="radio" id="customRadio4" name="customRadio" class="custom-control-input" value="STRICTLY CONFIDENTIAL" />
                                                <label class="custom-control-label small" for="customRadio4">STRICTLY CONFIDENTIAL</label>
                                            </div>
                                        </form>
                                    </div>
                                    
                                    <div>
                                        <p className="px-4 pt-2 mb-1 text-uppercase text-secondary font-weight-bold">
                                        dataset owner<span className="asterisk">*</span>
                                        </p>
                                        <input type="text" class="mx-4 w-75 form-control form-control-sm" onChange={this.handleChangeDatasetOwner} ></input>
                                    </div>

                                    <div>
                                        <p className="px-4 pt-2 mb-0 text-uppercase text-secondary font-weight-bold" title="Status of data">
                                        status
                                        </p>
                                        <form className="px-4 mb-2" onChange={this.handleChangeStatus} >
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="customRadioInline3" name="customRadioInline1" className="custom-control-input" value="Active"/>
                                                <label class="custom-control-label small" for="customRadioInline3">Active</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="customRadioInline4" name="customRadioInline1" className="custom-control-input" value="Inactive" />
                                                <label class="custom-control-label small" for="customRadioInline4">Inactive</label>
                                            </div>
                                        </form>
                                    </div>
                                
                                    <div>
                                        <p className="px-4 pt-2 mb-1 text-uppercase text-secondary font-weight-bold" title="How often is the data refreshed or updated?">
                                        frequency
                                        </p>
                                        <select  className="form-control form-control-sm w-75 mx-4" onChange={this.handleChangeFrequency} >
                                            <option disabled selected >--please pick a frequency--</option>
                                            {
                                                frequencyList.map(item=>{
                                                    return( <option>{item}</option> )
                                                })
                                            }   
                                        </select>
                                    </div>
                                
                                    <div>
                                        <p className="px-4 pt-2 mb-1 text-uppercase text-secondary font-weight-bold" title="Dataset source">
                                        back end
                                        </p>
                                        <input type="text" class="mx-4 w-75 form-control form-control-sm" onChange={this.handleChangeDatabaseManagementSystem} ></input>
                                    </div>

                                </div>
                            </div>
                            <div id="data-content" className="tab-pane fade">
                                <div className="w-75 float-left px-5 my-2">
                                    <div>
                                        <p className="px-4 pt-2 mb-1 text-uppercase text-secondary font-weight-bold" title="URL" >
                                        link to data
                                        </p>
                                        <input type="text" class="mx-4 w-75 form-control form-control-sm" onChange={this.handleChangeLinkToData} ></input>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    
                    
                </React.Fragment>
            )
        }
    }
}

export default Create